export function SupportPage() {
	return (
		<section className="panel">
			<h1 className="panel__title">お問い合わせ</h1>
			<p className="panel__text">
				サポートのご連絡は
				<a className="secondary-link" href="mailto:info@monello.jp">
					info@monello.jp
				</a>
				までお願いします。
			</p>
		</section>
	);
}

export default SupportPage;
